module.exports = "pegasus/assets/blocks/column-17-theme5.png";